export const FETCH_SITE_PROPERTIES_REQUEST = 'siteProperties/FETCH_REQUEST';
export const FETCH_SITE_PROPERTIES_SUCCESS = 'siteProperties/FETCH_SUCCESS';
export const FETCH_SITE_PROPERTIES_FAILURE = 'siteProperties/FETCH_FAILURE';
